import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { OrderService } from '../order.service';
import { Store } from '../models/store';
import { environment } from 'src/environments/environment';
import { Constants } from '../constants';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OffersComponent implements OnInit, OnDestroy {

  storeId:string;
  offerOrderId:string;
  store:Store;
  offers:any[];
  offerCatalogSharableLink;
  isLoading = true;
  offerOrder;
  userHash: string;
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService:OrderService,
    private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.storeId = this.route.snapshot.paramMap.get('storeId');
    this.offerOrderId = this.route.snapshot.paramMap.get('offerOrderId');
    this.userHash = localStorage.getItem('userHash') || '';
    if(!this.offerOrderId){
      let phoneNumber = localStorage.getItem(Constants.PHONE_NUMBER_KEY)
      if(phoneNumber){
        this.orderService.createTempOfferOrderWithPhone(this.storeId, phoneNumber).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.offerOrderId = data['offer_order_id']
          this.cdr.markForCheck();
          this.router.navigate(['store', this.storeId, 'offers', 'order', this.offerOrderId, 'available']);
        })
      }else{
        this.orderService.createTempOfferOrder(this.storeId).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.offerOrderId = data['offer_order_id']
          this.cdr.markForCheck();
          this.router.navigate(['store', this.storeId, 'offers', 'order', this.offerOrderId, 'available']);
        })
      }

    }else{
      forkJoin({
        store: this.orderService.getStoreInfo(this.storeId),
        offers: this.orderService.offers(this.storeId, this.offerOrderId)
      }).pipe(takeUntil(this.destroy$)).subscribe(({ store, offers }: any) => {
        this.store = Object.assign(new Store(), store);
        this.offerCatalogSharableLink = this.store.dynamic_offer_url
          ? this.store.dynamic_offer_url
          : `${environment.hostName}/store/${this.store.url_slug}/offers/`;
        this.offerOrder = offers.offer_order;
        this.offers = offers.offers;
        this.isLoading = false;
        this.cdr.markForCheck();
      });
    }
  }

  goToOffer(offer){
    this.router.navigate(['store', this.storeId, 'offers', 'order', this.offerOrderId, 'offer' , offer.id])
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack(){
    this.router.navigate(['store', this.storeId, 'offers', 'order', this.offerOrderId]);
  }

}
